"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentLicenseId = void 0;
/* eslint-disable @typescript-eslint/no-var-requires */
const dayjs = require('dayjs');
const isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);
function getCurrentLicenseId(organization) {
    const currentDate = dayjs();
    const startDate = dayjs(organization.startDate);
    const endDate = dayjs(organization.endDate);
    if (currentDate.isBetween(startDate, endDate, null, '[]')) {
        return organization.licenseId;
    }
    else {
        return organization.afterEndLicenseId;
    }
}
exports.getCurrentLicenseId = getCurrentLicenseId;
